import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "M9.545 5.844h4.91a.68.68 0 0 1 .68.68V19.28a.68.68 0 0 1-.68.68h-4.91a.68.68 0 0 1-.68-.68V6.523a.68.68 0 0 1 .68-.68Z" }, null, -1), l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.47 22.65h9.06c.87 0 1.585-.698 1.585-1.55V4.63c0-.852-.715-1.55-1.585-1.55h-2.039v-.616c0-.616-.507-1.114-1.132-1.114h-2.718c-.625 0-1.132.498-1.132 1.114v.616H7.47c-.87 0-1.585.698-1.585 1.55V21.1c0 .852.715 1.55 1.585 1.55ZM7.244 4.639c0-.109.1-.19.226-.19h3.397v-1.73h2.265v1.72h3.398c.127 0 .226.091.226.19v16.472c0 .108-.1.19-.226.19H7.47c-.127 0-.226-.09-.226-.19V4.639Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  n,
  l
];
function r(d, s) {
  return t(), c("svg", o, [...h]);
}
const v = { render: r };
export {
  v as default,
  r as render
};
